<template>
  <div class="page-title">
    <vs-col class="wrapper">
      <div>
        <h2>{{ heading }}</h2>
        <h6>{{ subHeading }}</h6>
      </div>
      <div>
        <vs-button v-if="!!buttonTitle" @click="onClickButton">
          {{ buttonTitle }}
        </vs-button>
      </div>
    </vs-col>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PageTitle.vue",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    onClickButton() {
      this.$emit("onClickButton");
    },
  },
  props: {
    heading: {
      type: String,
      required: true,
    },
    subHeading: {
      type: String,
      required: true,
    },
    buttonTitle: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss">
.page-title {
  flex: 1;

  .wrapper {
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 1px rgba(var(--vs-primary), 0.15);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 30px;

    h6 {
      margin-top: 5px;
    }
  }
}
</style>

